export default {
  header: "About",
  view: "About"
};
